import { useState } from "react";

export const InputWithToolTip = ({ wrapper, span, input }) => {
    const [showToolTip, setShowToolTip] = useState(false);

    return (
        <div className={wrapper?.className} style={Object.assign({}, wrapper?.style || {})}>
            <span
                className={span?.className}
                style={Object.assign(
                    {
                        display: showToolTip ? "block" : "none"
                    },
                    span?.style || {}
                )}>
                {span.placeholder}
            </span>
            <input
                required
                type={input?.type || "text"}
                placeholder={input?.value}
                value={input?.value}
                className={input?.className}
                onChange={input.onChange}
                onMouseOver={() => setShowToolTip(true)}
                onMouseLeave={() => setShowToolTip(false)}
            />
        </div>
    );
};
